import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import LoaderHomeEvent from "../../Components/pageLoader/LoaderHomeEvent";

const EvenMainPage = () => {
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true); // Loader state

  useEffect(() => {
    const fetcheventData = async () => {
      setLoading(true); // Start loading
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/eventCollection"
        );
        setEventData(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // Stop loading after data is fetched
      }
    };

    // Fetch data immediately and then set interval
    fetcheventData();
  }, []);

  return (
    <div className=" bg-rose-50 ">
      <div className="max-w-screen-4xl mx-auto 0  p-4">
        <div className="flex flex-col justify-center items-center ">
          <h1 className="text-center font-pacifico font-thin text-6xl text-rose-700 py-10">
           Our  Events
          </h1>
          <div
            className="h-1 w-full mb-10"
            style={{
              background:
                "linear-gradient(to right, transparent, #6B021A, transparent)",
            }}
          ></div>
          {/* <h1 className="text-4xl font-raleway mt-10 font-semibold text-rose-900">
          Let’s shop!
        </h1>
        <h2 className="text-xl font-raleway my-10 text-rose-800">
          Heart the items you love, check out, and within 1-2 days, one of our
          Event Specialists will send you a proposal or contact you for more
          information!
        </h2> */}
          {loading ? (
            <LoaderHomeEvent></LoaderHomeEvent>
          ) : (
            <div className="grid grid-cols-2 gap-2 w-full">
            {eventData.map((event) => (
              <div className="relative h-[500px]">
                {/* Video Background */}

                <img
                  className="absolute inset-0 w-full h-full object-cover"
                  src={event.singleImage}
                  alt=""
                ></img>

                {/* Overlay */}
                <div className="absolute inset-0 bg-black opacity-40"></div>

                {/* Content */}
                <section className="relative z-10 h-full">
                  <div className="flex justify-center flex-col gap-6 items-center h-full">
                    <h1 className="text-white text-5xl font-semibold font-raleway">
                      {event.EventTitle}
                    </h1>

                    <Link to={`/event-all-products/${event.EventValue}`}>
                      <button className="text-rose-900 text-2xl px-6 py-2 font-raleway bg-white">
                        Learn More
                      </button>
                    </Link>
                  </div>
                </section>
              </div>
            ))}
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EvenMainPage;
